import { SupportFormInputField } from './SupportFormInputField';

export const SubjectField = () => (
  <SupportFormInputField
    name="subject"
    label="Subject"
    inputProps={{
      isRequired: true,
    }}
  />
);
